import { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Select, Switch } from 'antd';
import { drawerWidth, formItemLayout, notifyMessages } from '../../utils/constants';
import { DrawerFormButtons } from '../../components/common/drawersFormButtons';
import AnomaliesServices from '../../services/anomaliesServices';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useDocumentCategoryContext } from '../../context/documentCategoryContext';


const UpdateAnomalie = ({ open, onClose, getAnomalies, recordData }) => {
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const { documentCategories } = useDocumentCategoryContext();

    const saveData = async (values) => {
        setLoadingButton(true);
        try {
            const respData = await AnomaliesServices.updateAnomalie(values);
            if (respData.success) {
                setLoadingButton(false);
                message.success(notifyMessages.operationSuccess);
                getAnomalies();
                onClose();
                setFieldsChanged(false);
            }
            else {
                message.error(notifyMessages.errorAccured);
                setLoadingButton(false);
            }

        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingButton(false);
        }
    }

    const categoryList = documentCategories.map(item => ({ value: item.id, label: item.description }));

    return (
        <Drawer
            title="Modifica anomalia"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"updateAnomalie"} />
            }
        >
            <Form
                id="updateAnomalie"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>

                    <Form.Item name="anomaliesID" initialValue={recordData.id} hidden={true}></Form.Item>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Nome"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.name}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Tipo documento"
                            name="categoryID"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.categoryID}
                        >
                            <Select
                                options={categoryList}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Attivo"
                            name="enabled"
                            valuePropName="checked"
                            initialValue={recordData.enabled}
                        >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default UpdateAnomalie;